import React from 'react';

import { Project } from '@clef/shared/types';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@clef/client-library';
import { AnyUser } from '@/components/OrgAdminProjectSettingsUserTable/types';

type ConfirmRemoveUserDialogProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  user?: AnyUser;
  selectedProject: Project;
};

export const ConfirmRemoveUserDialog = ({
  open,
  onCancel,
  onConfirm,
  user,
  selectedProject,
}: ConfirmRemoveUserDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Remove User</DialogTitle>
      <DialogContent>
        {t('Are you sure you want to remove user {{userEmail}} from project {{projectName}}?', {
          userEmail: user?.email,
          projectName: selectedProject.name,
        })}
      </DialogContent>
      <DialogActions>
        <Button id="remove-user-cancel" onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button id="remove-user-remove" onClick={onConfirm} color="secondary" variant="contained">
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};
